import React from "react";
import { Trans, useTranslation } from "@coworker/locales";
import { FixaText } from "../../../shared/wrappers/FixaText/FixaText";
import { SimpleHeader } from "../../../layout/components/SimpleHeader/SimpleHeader";
import FullScreenPopup from "../../../layout/components/FullScreenPopup/FullScreenPopup";
import FixaButton from "../../../shared/wrappers/FixaButton/FixaButton";
import LinkOutIconPath from "../../../shared/wrappers/FixaSSRIcon/paths/LinkOutIconPath";
import styles from "./unauthorizedpage.module.css";

const MY_IDENTITY_REQUEST_ACCESS_URL =
  "https://myidentity.apps.ikea.com/IdentityManager/page.axd?ContextID=VI_ITShop_ProductSelection&uid_accproductgroupsecond=9ceeb9a4-acfe-41cb-91bf-d20e4d1d0974&uid_accproductgroup=9ceeb9a4-acfe-41cb-91bf-d20e4d1d0974";

export const UnauthorizedPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles["unauthorized-page-wrapper"]}>
      <FullScreenPopup noPadding noAppBar>
        <SimpleHeader displayAllScreens />
        <div className={styles["content-wrapper"]}>
          <div className={styles["header-section"]}>
            <FixaText tagName="h1" textStyle="Heading.L">
              <Trans>unauthorizedTitleString</Trans>
            </FixaText>
            <FixaText
              tagName="p"
              textStyle="Body.M"
              className={styles["header-description"]}
            >
              <Trans>unauthorizedDescriptionString</Trans>
            </FixaText>
          </div>
          <div className={styles["button-section"]}>
            <FixaButton
              type="primary"
              fluid
              ssrIcon={LinkOutIconPath}
              iconPosition="trailing"
              text={t("requestAccessString")}
              onClick={() =>
                window.open(
                  MY_IDENTITY_REQUEST_ACCESS_URL,
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            />
          </div>
        </div>
      </FullScreenPopup>
    </div>
  );
};
